/** Display title from a typical ProfileService get-by-id response. */
export function pickProfileEntityTitle(res: unknown): string {
  const r = res as {
    data?: { title?: string; secondaryTitle?: string };
    title?: string;
  };
  return String(
    r?.data?.title || r?.data?.secondaryTitle || r?.title || "",
  ).trim();
}

/** Display name from StationProfileService get-by-id response. */
export function pickStationDisplayName(res: unknown): string {
  const r = res as {
    data?: { name?: string; secondaryName?: string };
    name?: string;
  };
  return String(
    r?.data?.name || r?.data?.secondaryName || r?.name || "",
  ).trim();
}

/** Display name from ClientProfileService get-by-id response. */
export function pickClientDisplayName(res: unknown): string {
  const r = res as {
    data?: { name?: string; account?: { title?: string } };
    name?: string;
  };
  return String(
    r?.data?.name || r?.data?.account?.title || r?.name || "",
  ).trim();
}

/** Plate number from VehicleProfileService get-by-id response. */
export function pickVehiclePlateNumber(res: unknown): string {
  const r = res as {
    data?: { plateNumber?: string };
    plateNumber?: string;
  };
  return String(r?.data?.plateNumber || r?.plateNumber || "").trim();
}
